"use client";

import { c as _c } from "react/compiler-runtime";
import { useSession } from "next-auth/react";
import { ReactNode } from "react";
import { EventReadAbsentMembers } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/absent-members/event-read-absent-members";
import { EventReadAgenda } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/agenda";
import { EventReadAttendedMembers } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/attended-members/event-read-attended-members";
import { EventReadHeader } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/header";
import { EventReadHonoredMembers } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/honoredMembers/";
import { EventReadRequestMembers } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/requests/event-read-request-members";
import UserParticipationActions from "@/app/(main)/_club_components/user-participation-actions";
import Button from "@/components/button";
import SubSeparator from "@/components/global/sub-separator";
import { ModalSkeleton } from "@/components/modal/modal-skeleton";
import { useClubDashboardQuery } from "@/queries/club/club-dashboard-queries";
import { useEventQuery } from "@/queries/event/event-queries";
import { useModalStore } from "@/stores/modal-store";
import { EventEnum } from "@/TS/Enums/global_enums";
import { Club } from "@/TS/Interfaces/global_interfaces";
import { isMember, isPresident } from "@/utils/global-utils";
interface ModalEventViewProps {
  type?: EventEnum;
  clubSlug?: string;
  startDate?: string;
  isPublic?: boolean;
  publicClub?: Club;
}
export default function ModalEventViewContent(t0) {
  const $ = _c(48);
  const {
    type,
    clubSlug,
    startDate,
    isPublic: t1,
    publicClub
  } = t0;
  const isPublic = t1 === undefined ? false : t1;
  const {
    status
  } = useSession();
  const isLogged = status === "authenticated";
  const {
    modalConfig
  } = useModalStore();
  const skeletonOptions = modalConfig?.modalOptions?.loader?.skeleton;
  const loaderComponent = modalConfig?.modalOptions?.loader?.component;
  let t2;
  if ($[0] !== startDate) {
    t2 = startDate?.split("T")[0];
    $[0] = startDate;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== clubSlug || $[3] !== t2 || $[4] !== type) {
    t3 = {
      type,
      clubSlug,
      startDate: t2
    };
    $[2] = clubSlug;
    $[3] = t2;
    $[4] = type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: event,
    isLoading: isEventLoading,
    isError: isEventError
  } = useEventQuery(t3);
  const t4 = event?.clubSlug;
  const t5 = !!event?.clubSlug;
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = {
      clubSlug: t4,
      enabled: t5
    };
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const {
    data: club,
    isLoading: isClubLoading,
    isError: isClubError
  } = useClubDashboardQuery(t6);
  let t7;
  if ($[9] !== club) {
    t7 = club ? isPresident(club) : false;
    $[9] = club;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const hasPresidentRole = t7;
  let t8;
  if ($[11] !== club) {
    t8 = club ? isMember(club) : false;
    $[11] = club;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const hasMemberRole = t8;
  if (isEventLoading || isClubLoading) {
    if (!skeletonOptions) {
      const t9 = loaderComponent as ReactNode;
      let t10;
      if ($[13] !== t9) {
        t10 = <div className="w-full h-[200px] flex items-center justify-center transition-[max-height] duration-300 ease-in-out max-h-[200px]">{t9}</div>;
        $[13] = t9;
        $[14] = t10;
      } else {
        t10 = $[14];
      }
      return t10;
    }
    const t9 = skeletonOptions?.className;
    const t10 = skeletonOptions?.header;
    const t11 = skeletonOptions?.title;
    const t12 = skeletonOptions?.content;
    let t13;
    if ($[15] !== t10 || $[16] !== t11 || $[17] !== t12 || $[18] !== t9) {
      t13 = <ModalSkeleton className={t9} header={t10} title={t11} content={t12} />;
      $[15] = t10;
      $[16] = t11;
      $[17] = t12;
      $[18] = t9;
      $[19] = t13;
    } else {
      t13 = $[19];
    }
    return t13;
  }
  if (!event) {
    return null;
  }
  if (isEventError || isClubError) {
    let t9;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <p className="text-center text-red-500 mt-6">Erreur lors de la récupération de l'événement</p>;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    return t9;
  }
  let t9;
  if ($[21] !== event.startDate) {
    t9 = new Date(event.startDate);
    $[21] = event.startDate;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = new Date();
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const isUpcoming = t9 > t10;
  let t11;
  if ($[24] !== event) {
    t11 = <EventReadHeader event={event} />;
    $[24] = event;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SubSeparator className="mt-4" marginBottom="mb-4" />;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== event) {
    t13 = <EventReadAgenda event={event} title="Ordre du jour" />;
    $[27] = event;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SubSeparator className="mt-4" marginBottom="mb-4" />;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== event || $[31] !== hasMemberRole || $[32] !== hasPresidentRole) {
    t15 = hasMemberRole && <><EventReadHonoredMembers event={event} title={"Membres \xE0 l'honneur"} type="honoredMembers" defaultMessage={"Aucun membre \xE0 l'honneur"} /><div className="flex flex-col md:flex-row justify-between gap-0 md:gap-8"><EventReadRequestMembers event={event} title={"Invit\xE9s en attente"} type="requestsInProcess" defaultMessage={"Aucun invit\xE9"} /><EventReadRequestMembers event={event} title={"Invit\xE9s confirm\xE9s"} type="requestsValidated" defaultMessage={"Aucun invit\xE9"} /></div><EventReadAbsentMembers event={event} title="Absents" type="absentMembers" defaultMessage="Aucun absent" hasPresidentRole={hasPresidentRole} /><EventReadAttendedMembers event={event} title={"Pr\xE9sents"} type="attendedMembers" />{event?.documentReportUrl && <div className="flex justify-center"><Button variant="filled" colorTheme="primary" className="mt-8 rounded-full w-fit mx-auto" onClick={() => {
          window.open(event?.documentReportUrl, "_blank");
        }}>Voir le compte rendu</Button></div>}</>;
    $[30] = event;
    $[31] = hasMemberRole;
    $[32] = hasPresidentRole;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t11 || $[35] !== t13 || $[36] !== t15) {
    t16 = <div className="p-6"><div className="flex flex-col p-8 rounded-lg bg-event bg-opacity-5">{t11}{t12}{t13}{t14}{t15}</div></div>;
    $[34] = t11;
    $[35] = t13;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== hasMemberRole || $[39] !== hasPresidentRole || $[40] !== isLogged || $[41] !== isPublic || $[42] !== isUpcoming || $[43] !== publicClub) {
    t17 = isPublic && !hasMemberRole && !hasPresidentRole && publicClub && isUpcoming && <div className="px-6 pb-6"><UserParticipationActions club={publicClub} isLogged={isLogged} presidentEmail={publicClub.president?.email} className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4" onParticipate={_temp} /></div>;
    $[38] = hasMemberRole;
    $[39] = hasPresidentRole;
    $[40] = isLogged;
    $[41] = isPublic;
    $[42] = isUpcoming;
    $[43] = publicClub;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t16 || $[46] !== t17) {
    t18 = <div className="transition-[max-height] duration-300 ease-in-out max-h-[1000px]">{t16}{t17}</div>;
    $[45] = t16;
    $[46] = t17;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  return t18;
}
function _temp(openForm) {
  useModalStore.setState(state => state.modalConfig ? {
    modalConfig: {
      ...state.modalConfig,
      modalOptions: {
        ...state.modalConfig.modalOptions,
        onClose: openForm
      }
    }
  } : state);
  useModalStore.getState().handleClose();
}